

export const isSIT = true;
//URL
export const baseUrl = 'https://mapsit.vodafoneidea.com:8105/chargingmanagement/api/';

export const serverCall = async (url, methodType, params, headerKey) => new Promise(async (resolve, reject) => {
    url = baseUrl + url;
    console.log(url)
    let stringifyParam = JSON.stringify(params);
    let header = { Accept: 'application/json', 'Content-Type': 'application/json' };
    if (headerKey) {
        header = { ...header, ...headerKey };
    }
    let controller = new AbortController()
    setTimeout(() => {
        controller.abort()
    }, 40000);    // 10,000 means 10 seconds    
    await fetch(url, {
        method: methodType,
        headers: header,
        // signal: controller.signal,
        body: stringifyParam
    }).then(response => response.json())
        .then((responseJSON) => {
            if (responseJSON.ERROR_STATUS) {
                resolve({ success: true, data: responseJSON })
            } else {
                resolve({ success: false, data: responseJSON })
            }
        })
        .catch(error => {
            resolve({ success: false, data: error })
            reject({ success: false, data: error })
        });
});

export const apis = {
    USER_LOGIN: '0/authenticate/userLogin',
    USER_LOGOUT: '0/authenticate/logout',
    FETCH_DATA: '1/fetchApiData',
    FETCH_BULK_PROCESS_DATA: "3/fetchApiData",
    UPLOAD_NEWTARIFF_DATA: '1/updateDataApi',
    UPLOAD_BULKUPLOAD_DATA: '3/uploadBulkData',
    FETCH_DATA_CATEGORY: '4/fetchApiData',
    DISCONNECTION_REQUEST: "4/updateDataApi",
    NOTIFICATIN_REQUEST: "5/updateDataApi",
    GET_NOTIFICATION_DETAILS: "5/fetchApiData",
    CREDIT_MANAGEMENT_GET_DATA: '2/fetchApiData',
    CREDIT_MANAGEMENT_UPDATE_DATA: '2/updateDataApi',
}
